import { bdbToUint8Array, isBchqTemplate } from './bdbUtils';

export const decodeResponsePayload = (respJson) => {
  const outer = respJson?.response || respJson;
  const payload = outer?.response;
  if (payload == null) throw new Error('Unexpected response shape');
  if (typeof payload === 'object' && !Array.isArray(payload)) return payload;
  if (typeof payload === 'string') return JSON.parse(atob(payload));
  return payload;
};

export const parseExtractSegments = (respJson, { requireBchq = false } = {}) => {
  const body = decodeResponsePayload(respJson);
  const segments = body?.segments || body?.sample?.segments || [];
  return segments
    .map((seg, index) => {
      const bdbBytes = seg?.bdb ? bdbToUint8Array(seg.bdb) : new Uint8Array(0);
      return {
        index,
        bdbBytes,
        level: seg?.bdbInfo?.level || 'UNKNOWN',
        subtype: seg?.bdbInfo?.subtype?.[0],
        others: seg?.others || {},
        raw: seg,
      };
    })
    .filter((seg) => {
      if (!seg.bdbBytes?.length) return false;
      if (requireBchq && !isBchqTemplate(seg.bdbBytes)) return false;
      return true;
    });
};

export const parseExtractRecordMeta = (respJson) => {
  const body = decodeResponsePayload(respJson);
  const others = body?.others || {};
  const toNum = (v) => {
    if (v == null || v === '') return null;
    const n = Number(v);
    return Number.isNaN(n) ? null : n;
  };
  return {
    mode: others['io.ooru.nist.face.mode'] || others['io.ooru.nist.iris.mode'] || null,
    inputImageCount: toNum(others.nist_input_image_count ?? others.nist_fusion_input_count),
    templateCount: toNum(others.nist_template_count ?? others.nist_fusion_output_count),
    facesDetected: toNum(others.nist_faces_detected),
    facesExtracted: toNum(others.nist_faces_extracted ?? others.nist_template_count),
    rawOthers: others,
  };
};

export const parseMatchDecisions = (respJson, modalityKey = 'FACE') => {
  const statusCode = respJson?.response?.statusCode;
  if (statusCode && statusCode !== 200) {
    throw new Error(respJson?.response?.statusMessage || 'Match failed');
  }
  const items = respJson?.data?.response?.response || respJson?.response?.response || [];
  if (!Array.isArray(items)) return [];

  return items.map((item, galleryIndex) => {
    const decisions = item?.decisions || {};
    const decision =
      decisions[modalityKey] ||
      decisions[Object.keys(decisions)[0]] ||
      {};
    const analytics = decision.analyticsInfo || {};
    const score = parseOptionalNumber(
      analytics.score ?? analytics.SCORE ?? analytics.similarity ?? decision.score
    );
    const threshold = parseOptionalNumber(analytics.threshold ?? analytics.THRESHOLD ?? decision.threshold);
    return {
      galleryIndex,
      decision,
      analytics,
      score,
      threshold,
      match: decision.match,
      raw: item,
    };
  });
};

function parseOptionalNumber(value) {
  if (value === null || value === undefined || value === '') return null;
  const n = typeof value === 'number' ? value : parseFloat(value);
  return Number.isNaN(n) ? null : n;
}

export const isBchiTemplate = (bytes) => {
  if (!bytes || bytes.length < 4) return false;
  return bytes[0] === 0x42 && bytes[1] === 0x43 && bytes[2] === 0x48 && bytes[3] === 0x49;
};
